import styled from 'styled-components';

export const BillShipStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 37px;

  .bill-head {
    display: flex;
    flex-direction: column;
    gap: 14px;

    & .bill-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      min-width: 200px;
      padding: 0 20px;
      background-color: ${({ theme }) => theme.colors.secondary};
    }

    & .bill-data {
      display: flex;
      gap: 5px;
      flex-direction: column;
    }
  }
  .ship-head {
    display: flex;
    flex-direction: column;
    gap: 14px;

    & .ship-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      min-width: 200px;
      padding: 0 20px;
      background-color: ${({ theme }) => theme.colors.secondary};
    }

    & .ship-data {
      display: flex;
      gap: 5px;
      flex-direction: column;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
